import React from 'react'
import PropTypes from 'prop-types'

export const Content = ({ className = '', children = null }) => (
  <section className={className}>{children}</section>
)

Content.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]),
}
